import Vue from 'vue'
import ManagerState, {
  AccountData,
  ArticleData,
  BaseData,
  CategoryData,
  CategoryWholeData,
  KajikiData,
  ModalState,
  SiteUrlModel,
  StorageData
} from './state'
import { SsoItem } from '../../api/kajiki/account'

export interface SetInitialKajikiDataRequest {
  kajikiList: KajikiData[]
  selected: KajikiData,
  userName: string,
  accountName: string,
  sso: SsoItem
}

export function setInitialKajikiData(state: ManagerState, request: SetInitialKajikiDataRequest): void {
  Vue.set(state, 'kajikiData', request.kajikiList)
  Vue.set(state, 'accountData', <AccountData>{
    kajikiId: request.selected.kajikiId,
    userName: request.userName,
    accountName: request.accountName,
    sso: request.sso
  })
  // カテゴリと記事の検索結果をリセットする。
  // kajikiId と 記事、カテゴリの整合性が合わなくなるのを防ぐ。
  state.articles = []
  state.categoryData = []
  Vue.set(state, 'categoryWholeData', undefined)
}

export function setBaseData(state: ManagerState, baseData: BaseData): void {
  Vue.set(state.baseData, 'start', baseData.start)
  Vue.set(state.baseData, 'count', baseData.count)
  Vue.set(state.baseData, 'total', baseData.total)
}

export function setStorageData(state: ManagerState, storageData: StorageData): void {
  Vue.set(state.storageData.storage, 'use', storageData.storage.use)
  Vue.set(state.storageData.storage, 'total', storageData.storage.total)
}

export function setArticlesData(state: ManagerState, articles: ArticleData[]): void {
  Vue.set(state, 'articles', articles)
}

export function setCategoryWholeData(state: ManagerState, categoryWholeData: CategoryWholeData): void {
  Vue.set(state, 'categoryWholeData', categoryWholeData)
}

export function setCategoryData(state: ManagerState, categoryData: CategoryData[]): void {
  Vue.set(state, 'categoryData', categoryData)
}

export function setModalState(state: ManagerState, modalState: ModalState): void {
  Vue.set(state, 'modalState', modalState)
}

export function setUrlModalState(state: ManagerState, siteUrlModel: SiteUrlModel): void {
  Vue.set(state, 'siteUrlModel', siteUrlModel)
}

export function updateContentSelection(state: ManagerState, { contentId, selected }: { contentId: number, selected: boolean }): void {
  state.articles
    .filter(article => article.contentId === contentId)
    .forEach(article => Vue.set(article, 'selected', selected))
}

export function updateAllContentSelection(state: ManagerState, { selected }: { selected: boolean }): void {
  state.articles
    .forEach(article => Vue.set(article, 'selected', selected))
}

export function setLoadingKajiki(state: ManagerState, value: boolean) {
  state.loading.kajiki = value
}

export function setLoadingArticle(state: ManagerState, value: boolean) {
  state.loading.article = value
}

export default {
  setBaseData,
  setInitialKajikiData,
  setArticlesData,
  setCategoryWholeData,
  setCategoryData,
  setModalState,
  setUrlModalState,
  updateContentSelection,
  updateAllContentSelection,
  setStorageData,
  setLoadingKajiki,
  setLoadingArticle
}
